import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { AppDropdownModel, AppDropdownModelOption } from './dropdown.types';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit {
  @Input() control!: FormControl;
  @Input() iconName: string | undefined;
  @Input() label: string | undefined;
  @Input() placeholder: string = '';
  @Input() isMarkedAsRequired: boolean = false;
  @Input() inputType: string = 'text';
  @Input() model: AppDropdownModel = {
    options: [],
  };

  shouldShowOptions: boolean = false;
  selectedOption: AppDropdownModelOption | null = null;

  constructor(private eRef: ElementRef) {}

  ngOnInit() {
    this.control.valueChanges.subscribe((value) => {
      this.selectedOption = this.model.options.find((o) => o.value === value)!;
    });
    return;
  }

  onBodyClick(): void {
    this.toggleOptionSelector();
    this.control.markAsTouched;
  }

  onOptionSelect(option: AppDropdownModelOption): void {
    this.control.setValue(option.value);
  }

  private toggleOptionSelector(): void {
    this.shouldShowOptions = !this.shouldShowOptions;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.control.markAsTouched;
      this.shouldShowOptions = false;
    }
  }
}
